import { render, staticRenderFns } from "./TesteEsterilizacao.vue?vue&type=template&id=1a14d4a1&"
import script from "./TesteEsterilizacao.vue?vue&type=script&lang=js&"
export * from "./TesteEsterilizacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports